import React from 'react';
import { CHEAT_SHEET } from './editorCopy';
import './editor.css';

/**
 * The right-rail "TYPE MARKDOWN, SEE FORMATTING" card shown while editing
 * (prototype C1-editor.md §1.7, verbatim copy). Rendered by page/WikiPage
 * first in the rail in edit mode. No props.
 */
export default function WikiEditorCheatSheet() {
    return (
        <section className="wk-ed-cheat" aria-labelledby="wk-ed-cheat-title" data-testid="wiki-editor-cheatsheet">
            <h2 id="wk-ed-cheat-title" className="wk-ed-cheat-eyebrow">{CHEAT_SHEET.eyebrow}</h2>
            <p className="wk-ed-cheat-text wk-ed-cheat-intro">{CHEAT_SHEET.intro}</p>
            <dl className="wk-ed-cheat-rows">
                {CHEAT_SHEET.rows.map(([code, label]) => (
                    <div key={label} className="wk-ed-cheat-row">
                        <dt><code className="wk-ed-cheat-code">{code}</code></dt>
                        <dd className="wk-ed-cheat-label">{label}</dd>
                    </div>
                ))}
            </dl>
            <p className="wk-ed-cheat-text wk-ed-cheat-foot">{CHEAT_SHEET.footer1}</p>
            <p className="wk-ed-cheat-text wk-ed-cheat-foot">{CHEAT_SHEET.footer2}</p>
        </section>
    );
}
